// extracted by mini-css-extract-plugin
module.exports = {"root":"K_bJ"};